export const host = process.env.VUE_APP_API_BEHEMOTH_HOST

export const wsHost = process.env.VUE_APP_API_BEHEMOTH_WS_HOST
export const wsKeycloakHost = process.env.VUE_APP_API_BEHEMOTH_WS_KEYCLOAK_HOST

export const baseURL = host + '/zebra_api/'
